import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { errorReportActions } from '_actions';
import { StatusCritical } from '_components';

class ErrorReport extends React.Component {


    handleClick() {
        this.props.send(undefined);
    }

    render() {
        return (
            <div>
                {!this.props.submitting &&
                    <StatusCritical title='Submit Error Report' onClick={() => this.handleClick()} />
                }
                {this.props.submitting &&
                    <div>Submitting Error Report.  This may take a few moments.  Please stand by...</div>
                }
                {!this.props.submitting && this.props.erno && this.props.erno !== -1 &&
                    <div>Last Error Report Submitted:  {this.props.erno}</div>
                }

            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        send: bindActionCreators(errorReportActions.send, dispatch)
    };
}

function mapStateToProps(state) {
    let submitting = state.ui.errorReport.submitting;
    let erno = state.ui.errorReport.lastErno;
    return {
        submitting,
        erno
    };
}


const connectedErrorReport = connect(mapStateToProps, mapDispatchToProps)(ErrorReport);
export { connectedErrorReport as ErrorReport }
